import React from "react";
import { Trophy, HeartHandshake } from "lucide-react";

import { Hero, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";

const awards = [
  {
    title: "2022 Presidential ZIKOMO Awards",
    description:
      "EasyBooks Solutions received the Presidential Excellence Award during the 2022 Presidential ZIKOMO Awards.",
    imageSrc: "Assets/Catalog/SAMSON FIADO with HE.jpg",
  },
  {
    title: "ICTAM 2020 ICT Innovation Awards",
    description:
      "Overall winner in the Fintech category with EasyBooks Accounting Software—built for SMEs and institutions.",
    imageSrc: "Assets/Catalog/receives-the-award.jpg",
  },
  {
    title: "ICTAM 2016 ICT Innovation Awards",
    description:
      "Received the Best Environmental Innovation Award for a Smart Waste Bin model designed to improve waste management.",
    imageSrc: "Assets/Catalog/Environmental Innovation Award.jpg",
  },
  {
    title: "2015 Spirit of Tech-I Award",
    description:
      "Received the Spirit of Tech-I Award by the US Department of State and AAAS at the Global Entrepreneurship Summit.",
    imageSrc: "Assets/Catalog/19678145593_94807c59ab_o.jpg",
  },
];

function SuccessStoties() {
  return (
    <div>
      <Seo
        title="Success Stories"
        description="Awards, recognition, and community impact stories from EasyBooks Solutions."
      />
      <Hero
        eyebrow="Success Stories"
        title="Award-winning delivery, built in Malawi."
        subtitle="Since 2019, EasyBooks Solutions has delivered innovative software and operational improvements across healthcare, education, finance, and government."
        primaryCta={{ label: "Work with us", to: "/Contact" }}
        secondaryCta={{ label: "Explore products", to: "/EasyBooks_Accounting" }}
        imageSrc="Assets/stacking-wood.jpg"
        imageAlt="Success stories"
        highlights={["Innovation awards", "Client outcomes", "Community impact"]}
      />

      <section className="eb-section bg-white">
        <div className="eb-container">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand-50 text-brand-800">
              <Trophy className="h-5 w-5" aria-hidden="true" />
            </div>
            <h2 className="eb-h2">Recognition & awards</h2>
          </div>

          <div className="mt-10 grid gap-6 md:grid-cols-2">
            {awards.map((a) => (
              <div key={a.title} className="eb-card overflow-hidden">
                <img
                  src={a.imageSrc}
                  alt={a.title}
                  className="h-100 w-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
                <div className="p-6">
                  <div className="text-lg font-semibold text-slate-900">{a.title}</div>
                  <p className="mt-3 text-sm text-slate-600">{a.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="eb-section bg-slate-50/60">
        <div className="eb-container">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand-50 text-brand-800">
              <HeartHandshake className="h-5 w-5" aria-hidden="true" />
            </div>
            <h2 className="eb-h2">Community & philanthropy</h2>
          </div>

          <div className="mt-10 grid gap-8 lg:grid-cols-2">
            <div className="eb-card p-6">
              <div className="text-lg font-semibold text-slate-900">
                Supporting local institutions
              </div>
              <p className="mt-3 text-sm text-slate-600 leading-6">
                Philanthropy is an important part of Malawi’s development. EasyBooks Solutions works hand-in-hand with
                institutions to drive social, economic, and environmental sustainability.
              </p>
              <div className="mt-6 text-sm font-semibold text-slate-900">
                Firm eases mobility challenges for a parish
              </div>
              <p className="mt-2 text-sm text-slate-600 leading-6">
                EasyBooks Solutions donated a motorbike to Lingidzi Anglican Diocese of Southern Malawi to support
                mobility needs.
              </p>
            </div>

            <div className="eb-card overflow-hidden">
              <img
                src="Assets/Catalog/DSC_4197.jpg"
                alt="Community impact"
                className="h-full w-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </section>

      <CTASection
        title="Want to build the next success story?"
        subtitle="If you have a workflow problem, we can help you solve it—fast and sustainably."
        primaryCta={{ label: "Contact us", to: "/Contact" }}
        secondaryCta={{ label: "Meet the team", to: "/Team" }}
      />
    </div>
  );
}

export default SuccessStoties;